export default "__VITE_ASSET__2iUcJhvmMa8PHbaOm3_3zA__"